export default __webpack_public_path__ + "public/assets/images/e1207227dedabeff5fc0723017622e76.png";